import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['status', 'project', 'wrapper', 'select', 'note', 'alert'];

  connect() {
    this.lifecycleStatusIds = (JSON.parse(this.data.get('statuses') || '[]')).map(String);
    this.originalStatus = this.data.get('original-status') || '';
    this.isEdit = this.data.get('edit') === 'true';
    this.projectFieldSelector = this.data.get('project-field') || '';
    this.boundRefresh = this.refresh.bind(this);

    // Bulk edit Project input sits outside this controller; listen directly.
    const external = this.projectFieldSelector && document.querySelector(this.projectFieldSelector);
    if (external) external.addEventListener('input', this.boundRefresh);

    this.refresh();
  }

  disconnect() {
    const external = this.projectFieldSelector && document.querySelector(this.projectFieldSelector);
    if (external) external.removeEventListener('input', this.boundRefresh);
  }

  refresh() {
    const projects = this.projects();
    const statusId = this.hasStatusTarget ? this.statusTarget.value : '';
    const hasLifecycle = this.lifecycleStatusIds.includes(String(statusId));
    const statusChanged = !this.isEdit || String(statusId) !== String(this.originalStatus);
    const active = hasLifecycle && statusChanged;

    if (this.hasNoteTarget) {
      this.noteTarget.classList.toggle('-state-hidden', !active);
    }

    if (this.hasAlertTarget) {
      this.alertTarget.classList.toggle('-state-hidden', !active);
    }

    // Project picker only when more than one project is entered.
    if (this.hasWrapperTarget && this.hasSelectTarget) {
      if (active && projects.length > 1) {
        this.populate(projects);
        this.wrapperTarget.classList.remove('-state-hidden');
        this.selectTarget.required = true;
      } else {
        this.wrapperTarget.classList.add('-state-hidden');
        this.selectTarget.required = false;
        this.selectTarget.value = '';
      }
    }
  }

  projectInput() {
    if (this.hasProjectTarget) return this.projectTarget;
    if (!this.projectFieldSelector) return null;
    return document.querySelector(this.projectFieldSelector);
  }

  projects() {
    const input = this.projectInput();
    return (input ? input.value : '')
      .split(',').map((p) => p.trim()).filter(Boolean);
  }

  populate(projects) {
    const current = this.selectTarget.value;
    this.selectTarget.innerHTML = '<option value="">Select a project…</option>';
    projects.forEach((project) => {
      const option = document.createElement('option');
      option.value = project;
      option.textContent = project;
      option.selected = project === current;
      this.selectTarget.appendChild(option);
    });
  }
}
